import React from "react";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../../redux/store";
import { setCartItems } from "../../../../redux/cart/slice";
import { cartSelector } from "../../../../redux/cart/selectors";
import { setSelectedSubscr } from "../../../../redux/subscriptions/slice";
import { setSelectedHalls } from "../../../../redux/halls/slice";
import { partnerIdSelector } from "../../../../redux/user/selectors";
import { cancelReserveArena } from "../../../../redux/rent/bitrixArenas";

import trashIcon from "../../../../assets/icons/trash.svg";
import subscriptionIcon from "../../../../assets/icons/subscription.svg";
import hallIcon from "../../../../assets/icons/hallType.svg";

import styles from "./CartIem.module.scss";

import { CartItemPropsType } from "./types";
import { ISelectedSubscr } from "../../../../redux/subscriptions/types";
import { ISelectedHall } from "../../../../redux/halls/types";

export const CartItem: React.FC<CartItemPropsType> = (props) => {
  const {
    itemId,
    itemType,
    date,
    time,
    price,
    title,
    quantity,
    expiration,
    expirationDays,
    setIsOpenModalNoAdultSbscr,
  } = props;

  const { totalCartItems } = useSelector(cartSelector);
  const partnerId = useSelector(partnerIdSelector);
  const dispatch = useAppDispatch();

  const cartItemTime = getRentTimeRange(time);
  const cartItemDate = getRentDate(date);

  function formatExpirationDuration(days?: number): string {
    if (!days) return expiration || "";
    
    if (days === 1) {
      return "1 день";
    } else if (days < 30) {
      return `${days} ${getDaysWord(days)}`;
    } else {
      const months = Math.round(days / 30);
      return `${months} ${getMonthsWord(months)}`;
    }
  }

  function getDaysWord(days: number): string {
    if (days % 10 === 1 && days % 100 !== 11) return "день";
    if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) return "дня";
    return "дней";
  }

  function getMonthsWord(months: number): string {
    if (months === 1) return "месяц";
    if ([2, 3, 4].includes(months)) return "месяца";
    return "месяцев";
  }

  const formattedExpiration = formatExpirationDuration(expirationDays);

  function getRentTimeRange(time: string | undefined) {
    if (time) {
      const startHour = `${Number(time.substring(0, 2).replaceAll(":", ""))}`;
      const endHour = `${Number(time.substring(0, 2).replaceAll(":", "")) + 1}`;

      const startRange = startHour.length === 1 ? `0${startHour}:00` : `${startHour}:00`;
      const endRange = endHour.length === 1 ? `0${endHour}:00` : `${endHour}:00`;

      return `${startRange} - ${endRange}`;
    }
  }

  function getRentDate(date: string | undefined) {
    if (date) {
      const rentDayName = dateFormat(new Date(Date.parse(date)), "ddd");
      const rentDay = dateFormat(new Date(Date.parse(date)), "dd");
      const rentYear = dateFormat(new Date(Date.parse(date)), "yyyy");

      const rentMonth = dateFormat(new Date(Date.parse(date)), "mmmm").toLowerCase();

      const rentMonthCorrected =
        rentMonth === "март" || rentMonth === "август"
          ? `${rentMonth}а`
          : `${rentMonth.substring(0, rentMonth.length - 1)}я`;

      return `${rentDayName} ${rentDay} ${rentMonthCorrected} ${rentYear}`;
    }
  }

  const handleDeleteCartItem = async () => {
    let cloneTotalCartItems = JSON.parse(JSON.stringify(totalCartItems));

    const cloneTotalCartItemsInType = JSON.parse(
      JSON.stringify(cloneTotalCartItems[itemType])
    );

    if (itemType === "seats") {
      const deletingHall = Object.values(cloneTotalCartItemsInType).find(
        (item: any) =>
          item.hallId === itemId &&
          item.time === time &&
          item.date === date
      ) as ISelectedHall | undefined;

      if (deletingHall && deletingHall.courtId && deletingHall.startTime && deletingHall.finishTime && partnerId) {
        try {
          await cancelReserveArena({
            partnerId: String(partnerId),
            newReserve: [],
            cancelReserve: [{
              courtId: deletingHall.courtId,
              startTime: deletingHall.startTime,
              finishTime: deletingHall.finishTime,
            }],
          });
        } catch (error) {
        }
      }
    }

    const filtredCloneTotalItemsInType = Object.keys(cloneTotalCartItemsInType)
      .filter((key) => {
        return itemType === "seats"
          ? cloneTotalCartItemsInType[key].hallId !== itemId ||
              cloneTotalCartItemsInType[key].time !== time ||
              cloneTotalCartItemsInType[key].date !== date
          : cloneTotalCartItemsInType[key].subscription.id !== itemId;
      })
      .reduce((res: { [key: string]: ISelectedSubscr | ISelectedHall | any }, key) => {
        res[key] = cloneTotalCartItemsInType[key];
        return res;
      }, {});

    if (itemType === "subscriptions") {
      const deletingItem = Object.keys(cloneTotalCartItemsInType)
        .filter((key) => cloneTotalCartItemsInType[key].subscription.id === itemId)
        .reduce((res: { [key: string]: ISelectedSubscr }, key) => {
          res[key] = cloneTotalCartItemsInType[key];
          return res;
        }, {});

      const delitingItemSbscrType = Object.values(deletingItem)[0].subscription.type;

      if (delitingItemSbscrType === "adult") {
        const doesItHaveAnotherAdult = Object.values(filtredCloneTotalItemsInType).find(
          (item) => item.subscription.type === "adult"
        );
        const doesItHaveKid = Object.values(filtredCloneTotalItemsInType).find(
          (item) => item.subscription.type === "kid"
        );

        if (!doesItHaveAnotherAdult && doesItHaveKid) {
          setIsOpenModalNoAdultSbscr(true);

          Object.keys(filtredCloneTotalItemsInType).forEach(
            (key) => delete filtredCloneTotalItemsInType[key]
          );
        }
      }

      dispatch(setSelectedSubscr(filtredCloneTotalItemsInType));
    }

    if (itemType === "seats") {
      dispatch(setSelectedHalls(filtredCloneTotalItemsInType));
    }

    cloneTotalCartItems[itemType] = filtredCloneTotalItemsInType;
    dispatch(setCartItems(cloneTotalCartItems));
  };

  return (
    <>
      <div id={`${itemId}`} className={styles.wrapper}>
        
        <div className={styles.icon}>
          <div className={styles.titleRow}>
            {
              itemType === "subscriptions" ? (
                <img src={subscriptionIcon} alt="Абонемент" />
              ) : (
                <img src={hallIcon} alt="Зал" />
              )
            }  

            <h3 className={styles.title}>{title}</h3>
          </div>
          <button className={styles.deleteButton} onClick={handleDeleteCartItem}>
            <img src={trashIcon} alt="Удалить" />
          </button>
        </div>

        <div className={styles.content}>
          {itemType === "subscriptions" && (
            <>
              {typeof quantity === "number" ? (
                <div className={styles.subscriptionsContent}>
                  <div className={styles.priceRow}>
                    <p className={styles.expiration}>Количество: </p>
                    <p className={styles.count}>{quantity}</p>
                  </div>
                  
                  <div className={styles.priceRow}>
                    {formattedExpiration && <p className={styles.detail}>на {formattedExpiration}</p>}
                    <p className={styles.price}>{price}₽</p>
                  </div>
                </div>
              ) : (
                <div className={styles.subscriptionsContent}>
                  <div className={styles.familyCounter}>
                    <div className={styles.priceRow}>
                      <p className={styles.expiration}>Количество взрослых: </p>
                      <p className={styles.count}>{quantity !== undefined && quantity[0]}</p>
                    </div>
                    <div className={styles.priceRow}>
                      <p className={styles.expiration}>Количество детских: </p>
                      <p className={styles.count}>{quantity !== undefined && quantity[1]}</p>
                    </div>
                  </div>
                  <div className={styles.priceRow}>
                    <p className={styles.detail}>на 1 месяц</p>
                    <p className={styles.price}>{price}₽</p>
                  </div>
                </div>
              )}
            </>
          )}

          {itemType === "seats" && (
            <>
              <p className={styles.detail}>{cartItemDate}, {cartItemTime}</p>
              <p className={styles.price}>{price}₽/час</p>
            </>
          )}
        </div>
      </div>
    </>
  );
};
